////////////////////////////////////////////////////////////
//     							                          //
//  Program: CompanyOverview.jsx                                //
//  Application: Dashboard                                //
//  Option: to view Company Information                   //
//  Developer: NP  						                            //
//  Date: 2022-04-11                                      //
//                                                        //
////////////////////////////////////////////////////////////
import Moment from "moment";
import React, { Component } from "react";
import { withRouter } from "react-router";
import CompanyService from "../../services/CompanyService";
// import companyLogo from './../../assets/images/company_placeholder.png'
import NoCleaning from "../../assets/images/snapshoticons/Cleaning.svg";

class CleaningToday extends Component {
  constructor(props) {
    super(props);

    this.state = {
      propertySlug: this.props.propertySlug,
      input: {},
      errors: {},
      isSubmit: false,
      showAlertModal: false,
      alertModalType: "",
      alertModalTitle: "",
      alertModalMessage: "",
      slug: "",
      total_client_count: "",
      checkins_today: [],
      checkouts_today: [],
      checkins_tomorrow: [],
      checkouts_tomorrow: [],
      checkInList: [],
      checkOutList: [],
      cleaningscheduled_today: [],
      cleaningscheduled_tomorrow: [],
      occupiedunits: [],
      bookedunits: [],
      signed_leases: [],
      new_booking_list: [],
    };
  }

  componentDidMount() {
    this.setState({ cleaningscheduled_today: [] });
    this.setState({ spinnerLoader: true, loading: true });
    if (this.state.propertySlug) {
      this.getData(this.state.propertySlug);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({ cleaningscheduled_today: [] });
    this.setState({ spinnerLoader: true, loading: true });
    if (nextProps.propertySlug) {
      this.getData(nextProps.propertySlug);
    }
  }
  // for cleaning scheduled
  handleClickcleanerList(property_slug, slug) {
    const win = window.open(
      "/properties/view/" + property_slug + "/housekeeping-list/" + slug,
      "_blank"
    );
    win.focus();
  }

  async getData(propertySlug) {
    this.setState({ spinnerLoader: true, loading: true });
    var resData = {};

    let res = await CompanyService.getCleaningScheduledToday(propertySlug);

    if (global.successStatus.includes(res.status)) {
      resData = res.data ? res.data : {};
      resData.cleaningscheduled_today = res.data.cleaningscheduled_today
        ? res.data.cleaningscheduled_today
        : [];
      resData.cleaningscheduled_today.sort((a, b) =>
        a.unit_name > b.unit_name ? 1 : -1
      );
    }
    this.setState(resData);
    this.setState({ spinnerLoader: false, loading: false });
  }

  render() {
    return (
      <div className="col-xxl-6 col-md-6 col-sm-12 col-12 mg-b-20">
        <div className="card card-table-two">
          <div className=" d-flex justify-content-between">
            <div className="">
              <h6 className="card-title">Cleaning Scheduled Today</h6>
              <span className="d-block mg-b-0">
                All cleanings on the schedule for today
              </span>
            </div>
            <h6 className="card-title">
              Total Count: {this.state.cleaningscheduled_today.length}
            </h6>
          </div>
          {this.state.cleaningscheduled_today.length > 0 ? (
            <div className="table-responsive">
              <table className="table table-dashboard-two mg-b-0">
                <thead>
                  <tr>
                    <th className="wd-lg-25p tx-left">S.No</th>
                    <th className="wd-lg-25p tx-left">Unit</th>
                    <th className="wd-lg-25p tx-left">Cleaner Name</th>
                    <th className="wd-lg-25p text-left">Scheduled On</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.cleaningscheduled_today.map((item, i) => {
                    return (
                      <tr
                        key={i}
                        value={item}
                        onClick={() =>
                          this.handleClickcleanerList(
                            item.property_slug,
                            item.slug
                          )
                        }
                      >
                        <td className="tx-left tx-medium tx-inverse hand-cursor td_clickable">
                          {i + 1}
                        </td>
                        <td className="tx-left tx-medium tx-inverse hand-cursor td_clickable">
                          {item.unit_name ? item.unit_name : ""}
                        </td>
                        <td className="tx-left tx-medium tx-inverse hand-cursor td_clickable">
                          {item.cleaner_name ? item.cleaner_name : ""}
                        </td>
                        <td className="text-left tx-medium tx-inverse hand-cursor td_clickable date_tbl_formate">
                          {item.scheduled_on
                            ? Moment(item.scheduled_on).format(
                                global.timeFormat
                              )
                            : ""}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          ) : (
            <>
              <div className="table-responsive overflow-hidden">
                {this.state.spinnerLoader ? (
                  global.snapshotloader
                ) : (
                  <div className="text-center">
                    <img src={NoCleaning} alt="" />
                    <p>No cleaning scheduled for today.</p>
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    );
  }
}
export default withRouter(CleaningToday);
